import { useTranslation } from 'react-i18next';
import type { DiffResult } from '@/services/copilot';
import styles from './VisualDiffViewer.module.css';

interface VisualDiffViewerProps {
  isOpen: boolean;
  onClose: () => void;
  diff: DiffResult | null;
  onAccept: (proposedText: string) => void;
  onReject: () => void;
}

export function VisualDiffViewer({
  isOpen,
  onClose,
  diff,
  onAccept,
  onReject,
}: VisualDiffViewerProps) {
  const { t } = useTranslation([
    'common',
    'nav',
    'board',
    'articles',
    'analytics',
    'feeddrive',
    'config',
    'strategist',
  ]);
  void t;
  if (!isOpen || !diff) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h3>Comparador Visual de Sugestões de IA</h3>
          <button className={styles.closeBtn} onClick={onClose}>
            Fechar
          </button>
        </div>

        <div className={styles.diffLegend}>
          <span className={styles.legendSeed}>Versão Semente Intocável (Human Seed)</span>
          <span className={styles.legendAddition}>+ Adição Sugerida</span>
          <span className={styles.legendDeletion}>- Remoção Proposta</span>
        </div>

        <div className={styles.diffBody}>
          {diff.diff_chunks.map((chunk, idx) => {
            if (chunk.type === 'addition') {
              return (
                <div key={idx} className={styles.additionLine}>
                  + {chunk.text}
                </div>
              );
            }
            if (chunk.type === 'deletion') {
              return (
                <div key={idx} className={styles.deletionLine}>
                  - {chunk.text}
                </div>
              );
            }
            return (
              <div key={idx} className={styles.unchangedLine}>
                {chunk.text}
              </div>
            );
          })}
        </div>

        <div className={styles.modalFooter}>
          <button
            className={styles.rejectBtn}
            onClick={() => {
              onReject();
              onClose();
            }}
          >
            − Rejeitar Sugestão (Manter Texto Original)
          </button>

          <button
            className={styles.acceptBtn}
            onClick={() => {
              onAccept(diff.proposed);
              onClose();
            }}
          >
            • Aceitar Sugestão e Criar Nova Revisão
          </button>
        </div>
      </div>
    </div>
  );
}
